import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentJointConfirmInformationData,
  type EnrollmentJointConfirmInformationSubmitOutput,
} from '../../../../models'
import {
  EnrollmentTaxFilingStatusType,
  PersonalNetWorthRange,
  EnrollmentInvestmentObjectiveCategory,
  EnrollmentInvestmentExperienceCategory,
  MaritalStatus,
} from '../../../../models'

export const getEnrollmentJointConfirmInformationDataMock: EnrollmentJointConfirmInformationData = {
  errors: [],
  isError: false,
  activePerson: {
    applicationId: '305802305',
    progress: 0.5,
    path: '/enrollment/joint/confirm-information',
    phone: {
      countryPhoneCode: 1,
      phoneNumber: '8044200000',
    },
    email: 'george.kanchev@evergreen.money',
    dateOfBirth: '1990-01-01',
    addressLine1: '7607 Old Georgetown Rd',
    addressLine2: '1000 Apt',
    addressCity: 'Bethesda',
    addressPostalCode: '20814-6442',
    addressRegionCode: 'MD',
    addressCountry: 'US',
    maskedTaxId: '***-**-7890',
    employmentStatus: 'EMPLOYED',
    occupation: 'OTHER',
    isBrokerDealerEmployer: false,
    isDirectorPolicyMaker: false,
    personalAnnualGrossIncome: 123123,
    personalNetWorthRange: PersonalNetWorthRange.BETWEEN_200K_AND_500K,
    name: {
      firstName: 'John',
      lastName: 'Doe',
    },
    maritalStatus: MaritalStatus.SINGLE,
    investmentObjective: EnrollmentInvestmentObjectiveCategory.BUILD_WEALTH,
    investmentExperience: EnrollmentInvestmentExperienceCategory.A_LOT,
    taxFilingStatus: EnrollmentTaxFilingStatusType.SINGLE,
    isPoliticallyExposedPerson: false,
    affiliatedPoliticalOrganizations: [],
    hasPoliticallyExposedImmediateFamilyMembers: false,
    politicallyExposedImmediateFamilyMembers: [],
  },
}

export const submitEnrollmentJointConfirmInformationDataMock: EnrollmentJointConfirmInformationSubmitOutput = {
  errors: [],
  isError: false,
  activePerson: {
    applicationId: '305802305',
    name: {
      firstName: 'John',
      lastName: 'Doe',
    },
    path: '/enrollment/joint/disclosures',
    progress: 0.6,
  },
}

export const mockGetEnrollmentJointConfirmInformationData = graphql.mutation(
  'getEnrollmentJointConfirmInformationData',
  () => {
    return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointConfirmInformationDataMock } })
  },
)

export const mockSubmitEnrollmentJointConfirmInformationData = graphql.mutation(
  'submitEnrollmentJointConfirmInformationData',
  () => {
    return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointConfirmInformationDataMock } })
  },
)

export const mockEnrollmentJointConfirmInformation = [
  mockGetEnrollmentJointConfirmInformationData,
  mockSubmitEnrollmentJointConfirmInformationData,
]
